import { localize } from "render/context/InternationalizationContext";

const Title = localize({
  en_GB: <>Doctor's Note</>,
  sv_SE: <>Läkarens bedömning</>,
});

export const Trans = { Title };
